export default "__VITE_ASSET__iN0tZ_fJ__"